import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appFocusClickOnTab]',
})
export class FocusClickOnTabDirective {
  private tabPressed = false;
  private hasClickedOnTabFocus = false;

  constructor(private readonly el: ElementRef) {}

  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      this.tabPressed = true;
      this.hasClickedOnTabFocus = false;
    }
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyUp(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      this.tabPressed = false;
    }
  }

  @HostListener('focus')
  onFocus() {
    console.log(this.tabPressed, this.hasClickedOnTabFocus);
    if (this.tabPressed && !this.hasClickedOnTabFocus) {
      this.hasClickedOnTabFocus = true;
      setTimeout(() => {
        this.el.nativeElement.click();
      }, 0);
    }
  }
}
